import styles from './receta-page.module.scss';
import React from "react";
import { Link } from "react-router-dom";

import api, { Recipe } from "../../services/api";

export interface RecetaPageProps {
  name?: string;
  classes?: string;
  match?: { slug?: string };
}

interface State {
  recipe: Recipe | null;
  loading: boolean;
  notFound: boolean;
}

/**
 * Detalle de receta (Figma `Recetario-1…10`). Datos del API (`/api/recipes/:slug`).
 */
export default class RecetaPage extends React.Component<RecetaPageProps, State> {
  static jsClass = "RecetaPage";
  static defaultProps: Partial<RecetaPageProps> = {
    name: "mbReceta",
  };

  state: State = { recipe: null, loading: true, notFound: false };

  componentDidMount() {
    const slug = this.props.match?.slug ?? "";
    api
      .getRecipe(slug)
      .then((recipe) => this.setState({ recipe, loading: false, notFound: !recipe }))
      .catch(() => this.setState({ loading: false, notFound: true }));
  }

  render(): React.ReactNode {
    const { classes } = this.props;
    const { recipe, loading, notFound } = this.state;

    if (loading) {
      return <section className={styles['mb-notfound']}><p>Cargando receta…</p></section>;
    }

    if (notFound || !recipe) {
      return (
        <section className={styles['mb-notfound']}>
          <h1 className={styles['mb-notfound__title']}>Receta no encontrada</h1>
          <p className={styles['mb-notfound__copy']}>
            La receta que buscas no existe o cambió de dirección.
          </p>
          <Link className={styles['mb-btn']} to="/recetario">
            Volver al recetario
          </Link>
        </section>
      );
    }

    return (
      <article className={styles['mb-receta'] + (classes ? ' ' + classes : '')}>
        <div className={styles['mb-receta__grid']}>
          {/* ── Columna izquierda ─────────────────────────────────────────── */}
          <div className={styles['mb-receta__main']}>
            <h1 className={styles['mb-receta__title']}>{recipe.titulo}</h1>

            <ul className={styles['mb-meta']}>
              <li>
                <span className={styles['mb-meta__k']}>Tiempo de preparación:</span>{" "}
                {recipe.tiempo_preparacion}
              </li>
              {recipe.tipo_platillo && (
                <li>
                  <span className={styles['mb-meta__k']}>Tipo de platillo:</span>{" "}
                  {recipe.tipo_platillo}
                </li>
              )}
              <li>
                <span className={styles['mb-meta__k']}>Porciones:</span> {recipe.porciones}
              </li>
              <li>
                <span className={styles['mb-meta__k']}>
                  Producto Mangibone utilizado:
                </span>{" "}
                {recipe.producto}
              </li>
            </ul>

            <p className={styles['mb-receta__h']}>Preparación:</p>
            <ol className={styles['mb-steps']}>
              {recipe.pasos.map((paso, index) => (
                <li key={`${index}-${paso}`}>{paso}</li>
              ))}
            </ol>

            <div className={styles['mb-receta__actions']}>
              <Link className={styles['mb-btn']} to="/productos">
                Ir a comprar
              </Link>
              <Link className={styles['mb-btn']} to="/recetario">
                Recetario
              </Link>
            </div>
          </div>

          {/* ── Columna derecha (navy) ────────────────────────────────────── */}
          <aside className={styles['mb-receta__side']}>
            <img
              className={styles['mb-receta__img']}
              src={recipe.imagen}
              alt={recipe.titulo}
            />
            <h2 className={styles['mb-receta__h'] + ' ' + styles['mb-receta__h--light']}>
              Ingredientes
            </h2>
            <ul className={styles['mb-ingredients']}>
              {recipe.ingredientes.map((ingrediente) => (
                <li key={ingrediente}>{ingrediente}</li>
              ))}
            </ul>
            <p className={styles['mb-receta__product']}>{recipe.producto}</p>
          </aside>
        </div>
      </article>
    );
  }
}
